import { render, staticRenderFns } from "./TaskDo.vue?vue&type=template&id=36ffb862&scoped=true&"
import script from "./TaskDo.vue?vue&type=script&lang=js&"
export * from "./TaskDo.vue?vue&type=script&lang=js&"
import style0 from "./TaskDo.vue?vue&type=style&index=0&id=36ffb862&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ffb862",
  null
  
)

export default component.exports